import { jsx as m } from "react/jsx-runtime";
import f from "classnames";
import h from "../../utils/colors.js";
import { f as s } from "../../styled-qu50FBLM.mjs";
import { Svg as p, Path as d } from "./Elements.js";
const x = ({
  className: r = "",
  fill: t = h.blueGrey,
  d: a = "M18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h1v4l4-4h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-5 3.75A1.25 1.25 0 1 1 11.75 5 1.25 1.25 0 0 1 13 3.75zm-6 0A1.25 1.25 0 1 1 5.75 5 1.25 1.25 0 0 1 7 3.75zM10 12a5 5 0 0 1-4.58-3h9.16A5 5 0 0 1 10 12z",
  viewBox: i = "0 0 20 20",
  $transition: e = "fill 0.1s ease-in-out",
  $cssHelper: l = s,
  focusable: o
}) => /* @__PURE__ */ m(
  p,
  {
    className: f({ [r]: !!r }),
    viewBox: i,
    $cssHelper: l,
    focusable: !!o,
    "aria-hidden": !o,
    children: /* @__PURE__ */ m(d, { fill: t, d: a, $transition: e })
  }
);
export {
  x as default
};
